export const ADD_FREE_GIFT_TO_CART_START = 'ADD_FREE_GIFT_TO_CART_START';

export const ADD_FREE_GIFT_TO_CART_SUCCESS = 'ADD_FREE_GIFT_TO_CART_SUCCESS';

export const ADD_FREE_GIFT_TO_CART_FAILURE = 'ADD_FREE_GIFT_TO_CART_FAILURE';
